module.exports = __webpack_public_path__ + "img/border4.0d842ac9.png";